export default __webpack_public_path__ + "static/elyxr-page-animation-sample-poster-925bd54c0df230f8017f6e0717ff30e1.png";